import { cloneData, DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../dto/dto.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { Price } from '../price.js';
import { CartItemDto } from './cart-item.js';
import { VersionRange } from '../../core/version-range.js';

export class DonationCartItemDto extends CartItemDto {
  static readonly TYPE_ID: string = 'a3add96a664044daba0cb45e10c7a832';
  static readonly SCHEMA_VERSION: number = 1;
  static readonly UNIQUE_ID: string = 'donation';

  public readonly uniqueId: string = DonationCartItemDto.UNIQUE_ID;
  public readonly quantity: number = 1;

  public readonly originalUnitPrice: Price | null;
  public readonly totalPrice: Price;

  private constructor(
    public readonly unitPrice: Price,
  ) {
    super();
    this.totalPrice = unitPrice;
    this.originalUnitPrice = null;
  }

  get $typeId(): string {
    return DonationCartItemDto.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    // Version should always be `exactly`.
    // Cart should never be backwards migrated, backend should be updated before frontend.
    return VersionRange.exactly(DonationCartItemDto.SCHEMA_VERSION);
  }

  static create({ amount }: { amount: Price }) {
    return new DonationCartItemDto(amount);
  }

  static fromMap(context: SerializationContext, map: SerializedData): DonationCartItemDto {
    return new DonationCartItemDto(
        Price.decode(MapUtils.getString(map, 'unitPrice')),
    );
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'unitPrice': this.unitPrice.encode(),
    };
  }

  clone(): this {
    return new DonationCartItemDto(
        cloneData(this.unitPrice),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.unitPrice, this.unitPrice);
  }

  static verifyType(item: CartItemDto): boolean {
    return item instanceof DonationCartItemDto;
  }

  static assertType(item: CartItemDto): item is DonationCartItemDto {
    return item instanceof DonationCartItemDto;
  }
}

export class DonationCartItemDtoBuilder extends DataModelBuilder<DonationCartItemDto> {
  build(context: SerializationContext, map: SerializedData): DonationCartItemDto {
    return DonationCartItemDto.fromMap(context, map);
  }
}

